import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EoFormPanelConfig } from '../eo-form-panel/eo-form-panel.model';
import { FormConfig } from '../eo-base-form-control/eo-base-form-control.model';
import { debounceTime, Subscription } from 'rxjs';

@Component({
  selector: 'eo-form',
  templateUrl: './eo-form.component.html',
  styleUrl: './eo-form.component.scss',
})
export class EoFormComponent {
  subscriptions: Subscription[] = [];
  form: FormGroup = this.fB.group({});

  private _config: FormConfig | EoFormPanelConfig[] = [];
  @Input() set config(val: FormConfig | EoFormPanelConfig[]) {
    this._config = val;
    this.form = this.getForm();
    this.form?.reset();
  }
  get config() {
    return this._config;
  }

  get valid() {
    return this.form.valid;
  }
  @Input() customFormControls: { [key: string]: TemplateRef<any> | null } = {};
  @Input() validate = true;
  @Input() submitButtonVisible = true;
  @Input() submitButtonLoading = false;
  @Input() submitButtonLabel = 'Αποθήκευση';
  @Input() submitButtonStyleClass?: string;
  @Input() submitButtonDivStyleClass?: string;
  @Input() icon?: string;
  @Output() formSubmit = new EventEmitter<any>();
  @Output() formChange = new EventEmitter<any>();

  constructor(private readonly fB: FormBuilder) {}

  ngOnInit() {
    this.subscriptions = [this.getOnFormChangeSubscription()];
  }

  getOnFormChangeSubscription(): Subscription {
    return this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.formChange.emit(this.getFormData());
    });
  }

  getForm() {
    let fg = EoFormPanelConfig.getFormFromConfig(
      this.config as EoFormPanelConfig[],
      this.fB
    );
    if (!fg) return this.fB.group({});
    return fg;
  }

  getFormControl(formGroupName: string, formControlName: string) {
    return this.form.get(formGroupName)?.get(formControlName);
  }

  setValue(formGroupName: string, formControlName: string, value: any): void {
    this.getFormControl(formGroupName, formControlName)?.setValue(value);
  }

  getConfig() {
    return this.config as EoFormPanelConfig[];
  }

  isSubmitButtonVisible(): boolean {
    return this.submitButtonVisible;
  }

  getSubmitButtonLabel(): string {
    return this.submitButtonLabel;
  }

  getSubmitButtonStyleClass(): string | undefined {
    return this.submitButtonStyleClass;
  }

  getSubmitButtonDivStyleClass(): string | undefined {
    return this.submitButtonDivStyleClass;
  }

  getIcon(): string | undefined {
    return this.icon;
  }

  isSubmitButtonDisabled(): boolean {
    return this.validate && !this.form.valid;
  }

  isSubmitButtonLoading(): boolean {
    return this.submitButtonLoading;
  }

  getFormData(): any {
    return EoFormPanelConfig.getFormData(this.form);
  }

  onSubmit() {
    console.log('Form submitted');
    
    if (this.validate && !this.valid) return;

    let formData = EoFormPanelConfig.getFormData(this.form);
    this.formSubmit.emit(formData);
  }
}
